//size
export const SIZE_SMALL = 'sm';
export const SIZE_MEDIUM = 'md';
export const SIZE_LARGE = 'lg';
export const SIZE_XL = 'xl';

//backdrop
export const BACKDROP_STATIC = 'static';

//modal action
export const MODAL_ACTION_DELETE = 'Delete';
export const MODAL_ACTION_CANCEL = 'Cancel';
export const MODAL_ACTION_REMOVE = 'Remove';
export const MODAL_ACTION_CLEAR = 'Clear';

//warning
export const WARNING_LEVEL_DANGER = 'danger';
